import { debounce, isSurfTemplate } from '@/utils/api';
import store from '@/store';
import { DEVICE_RESIZE_DELAY } from '@rebuild/hooks/useDeviceResize';

const docElm = document.documentElement;

// 与 postcss-pxtorem 的 rootValue 保持一致
const ROOT_VALUE = 100;
// 设计稿基准配置
const MOBILE_WIDTH = 375;
const PC_WIDTH = 1440;
// 切换断点
const SWITCH_POINT = 760;

let scrollbarWidth;
const getScrollbarWidth = () => {
	// 初始化第一次判断是否存在滚动条
	if (docElm.scrollHeight <= docElm.clientHeight) return 0;
	if (scrollbarWidth) return scrollbarWidth;

	// 创建一个临时的div元素
	let outer = document.createElement('div');
	outer.style.visibility = 'hidden'; // 使其不可见
	outer.style.overflow = 'scroll'; // 使其包含滚动条
	document.body.appendChild(outer);

	// 获取滚动条的宽度
	scrollbarWidth = outer.offsetWidth - outer.clientWidth;
	// 移除临时的div元素
	document.body.removeChild(outer);

	return scrollbarWidth;
};

const setRootFontWithNormalTmpl = () => {
	// 获取屏幕可用宽度
	const screenWidth = screen.availWidth;

	// 适配宽度比例
	const scrollbarW = getScrollbarWidth();
	let adjustedWidth;
	if (screenWidth.width / screenWidth.height > 16 / 9) {
		adjustedWidth = (screenWidth.height / 9) * 16;
	} else {
		adjustedWidth = screenWidth;
	}
	adjustedWidth += scrollbarW;

	// 获取视口宽度
	const viewportWidth = docElm.clientWidth;

	// mobile: 760px
	const isPC = viewportWidth > SWITCH_POINT;
	store.commit('setAccessMode', isPC);

	// 动态设置font-size
	if (adjustedWidth < PC_WIDTH && adjustedWidth > SWITCH_POINT) {
		docElm.style.fontSize = isPC
			? `${ROOT_VALUE * (adjustedWidth / PC_WIDTH)}px`
			: `${ROOT_VALUE * (viewportWidth / MOBILE_WIDTH)}px`;
	} else {
		docElm.style.fontSize = isPC ? `${ROOT_VALUE}px` : `${ROOT_VALUE * (viewportWidth / MOBILE_WIDTH)}px`;
	}
};

const setRootFontWithSurfTmpl = () => {
	const PC_WIDTH_IN_SURF_TMPL = 1920; // 1920 的基准能更好的适配 1440*731 的屏幕

	// 限定字号边界
	const MIN_FONT_SIZE = 60;
	const MAX_FONT_SIZE = 110;

	// 使用 clientWidth，自动排除滚动条
	const viewportWidth = docElm.clientWidth || window.innerWidth;

	// 根据断点选择设计稿基准
	const designWidth = viewportWidth <= SWITCH_POINT ? MOBILE_WIDTH : PC_WIDTH_IN_SURF_TMPL;

	// mobile: 760px
	const isPC = viewportWidth > SWITCH_POINT;
	store.commit('setAccessMode', isPC);

	let fontSize = (viewportWidth / designWidth) * ROOT_VALUE;
	fontSize = Math.max(MIN_FONT_SIZE, Math.min(MAX_FONT_SIZE, fontSize));

	docElm.style.fontSize = fontSize + 'px';
};

export function setRootFont() {
	const isSurfTmpl = isSurfTemplate();
	if (isSurfTmpl) return setRootFontWithSurfTmpl();

	return setRootFontWithNormalTmpl();
}

// 改变窗口大小时重新设置 rem
const onResizeRem = debounce(setRootFont, DEVICE_RESIZE_DELAY);
window.addEventListener('resize', onResizeRem, DEVICE_RESIZE_DELAY);
// 立即执行一次
setRootFont();
